import { render, staticRenderFns } from "./send_data.vue?vue&type=template&id=4ed31d5b&"
import script from "./send_data.vue?vue&type=script&lang=js&"
export * from "./send_data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports